import { render, staticRenderFns } from "./notification-list-page.vue?vue&type=template&id=05277bca&scoped=true&"
import script from "./notification-list-page.vue?vue&type=script&lang=js&"
export * from "./notification-list-page.vue?vue&type=script&lang=js&"
import style0 from "./notification-list-page.vue?vue&type=style&index=0&id=05277bca&scoped=true&lang=css&"
import style1 from "./notification-list-page.vue?vue&type=style&index=1&id=05277bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05277bca",
  null
  
)

export default component.exports
import {QScrollObserver,QInfiniteScroll,QSpinnerDots,QBreadcrumbs,QIcon,QBreadcrumbsEl,QInnerLoading,QSpinnerIos,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollObserver,QInfiniteScroll,QSpinnerDots,QBreadcrumbs,QIcon,QBreadcrumbsEl,QInnerLoading,QSpinnerIos,QImg})
